import {
  jb_section_sitemap_css_default
} from "./chunk.I6TR2AHI.js";
import {
  Linkable
} from "./chunk.LK5OUX7S.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-section-sitemap/jb-section-sitemap.ts
var JbSectionSitemap = class extends Linkable(r) {
  _renderItems(items) {
    return items.map((item) => ke`<li><jb-anchor .link=${item.link}>${item.text}</jb-anchor></li>`);
  }
  render() {
    return ke`
      <section class="${Rt({ intranet: this.intranetStyle })}">
        <nav>
          <h2><jb-anchor .link=${this.link}>${this.text}</jb-anchor></h2>
          <ul>
            ${this._renderItems(this.items)}
          </ul>
        </nav>
      </section>
    `;
  }
};
JbSectionSitemap.styles = jb_section_sitemap_css_default;
__decorateClass([
  n({ type: Boolean })
], JbSectionSitemap.prototype, "intranetStyle", 2);
__decorateClass([
  n({ type: Array })
], JbSectionSitemap.prototype, "items", 2);
__decorateClass([
  n()
], JbSectionSitemap.prototype, "text", 2);
JbSectionSitemap = __decorateClass([
  customElement("jb-section-sitemap")
], JbSectionSitemap);

export {
  JbSectionSitemap
};
